module.exports = __webpack_public_path__ + "media/images/brand/lander/center-ea1f75638fc3c961a9e1f13611435452.png";